import React, { createContext, useContext, useState } from 'react';

const TabContext = createContext();

export default function TabProvider({ children }) {
    const [activeTab, setActiveTab] = useState(null); // { id, name, status, orderCount }
    return (
        <TabContext.Provider value={{ activeTab, setActiveTab }}>
            {children}
        </TabContext.Provider>
    );
}

export function useTab() {
    const ctx = useContext(TabContext);
    if (!ctx) throw new Error('useTab must be used within TabProvider');
    return ctx;
}
